<script src="../../shopfront/store.js"></script>
<template>
  <div>
    <Header
      :init-search="searchKeyword"
      :seller-logo-url="sellerLogoUrl"
      :logged-in="loggedIn"
      @changeSearchTerm="setSearch"
      @openCategoryMobile="toggleCategory"
    />
    <main>
      <div v-if="noResults">
        No results
      </div>
      <div class="catalogue">
        <CategoryPicker
          v-if="!noResults"
          :categories="categories"
          :init-selected-category-id="selectedCategoryID"
          :hide-category="hideMobileCategory"
          :is-landing-page="showLanding"
          :enable-new-landing="enableNewLanding"
          @changeCategory="setCategory"
          @closeCategory="toggleCategory"
        />
        <div v-if="!showLanding">
          <transition name="fadeInOut">
            <div v-if="searchKeyword" class="search-header">
              Showing results for "{{ searchKeyword }}" &nbsp; <a @click="setSearch(null)">Clear search</a>
            </div>
          </transition>

          <transition name="fadeInOut">
            <ProductGrid v-if="!noResults && !loading" :products="products" />
          </transition>

          <transition name="fadeInOut">
            <Pagination :init-current-page="pageNum" :init-total-pages="totalPages" @pageChanged="pageChange" />
          </transition>
        </div>
        <div v-else>
          <transition name="fadeInOut">
            <ShopLanding
              :featured-products="featuredProducts"
              :categories="categories"
              :shop-name="shopName"
              :shop-welcome-message="shopWelcomeMessage"
              @changeCategory="setCategory"
            />
          </transition>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import Header from '../header.vue';
import ProductGrid from '../product_grid';
import CategoryPicker from "../category-picker";
import Pagination from "../../pagination";
import ShopLanding from "./shop_landing"
import { listProducts, listCategories } from "../../../shopfront/cartDataService";
export default {
  components: { CategoryPicker, Header, ProductGrid, Pagination, ShopLanding },
  props: {
    buyers: { type: String, required: false },
    loggedIn: { type: Boolean, required: true },
    sellerLogoUrl: { type: String, required: true },
    enableNewLanding: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      cart: this.initCart,
      products: null,
      hideMobileCategory: true,
      categories: null,
      searchKeyword: '',
      noResults: false,
      pageNum: 1,
      totalPages: 0,
      selectedCategoryID: 'all',
      onSaleProductCount: null,
      showOnSaleCategory: false
    }
  },
  methods: {
    refreshResults: function() {
      let vm = this
      vm.loading = true;

      let options = {
        categoryId: this.selectedCategoryID,
        sellerPid: this.$store.state.sellerPid,
        searchKeyword: this.searchKeyword,
        buyerId: this.$store.state.buyerDetails.buyer_id,
        pageNum: this.pageNum
      }

      if (vm.showLanding) {
        listCategories(options, (response) => {
          vm.featuredProducts = response.featuredProducts
          vm.categories = response.categories
          vm.shopName = response.shopName
          vm.shopWelcomeMessage = response.shopWelcomeMessage
          vm.loading = false;
        })
        return;
      }

      listProducts(options, (response) => {
            vm.products = response.products
            vm.categories = response.categories
            vm.totalPages = response.total_pages

            if (!vm.products.length && vm.searchKeyword && vm.selectedCategoryID && vm.selectedCategoryID !== 'all') {
              vm.selectedCategoryID = 'all';
              vm.setQueryParams();
            }

            if (!vm.products.length && !vm.activeCategories.length) {
              vm.noResults = true;
            }

            vm.loading = false;

          })
    },
    pageChange: function(pageNum) {
      this.pageNum = pageNum;
      window.scrollTo(0,0);
      this.setQueryParams()
    },
    setCategory: function(categoryId) {
      this.selectedCategoryID = categoryId
      this.pageNum = null;

      if(!categoryId) {
        this.searchKeyword = null;
      }

      this.setQueryParams()
    },
    setSearch: function(keyword) {
      this.searchKeyword = keyword
      this.pageNum = 1;
      this.selectedCategoryID = 'all'
      this.loading = true;
      this.setQueryParams()
    },
    setQueryParams: function() {
      let newQuery = {}

      if (this.selectedCategoryID) {
        newQuery.cid = this.selectedCategoryID
      }

      if (this.pageNum)
      newQuery.page = this.pageNum;

      if (this.searchKeyword) {
        newQuery.kw = this.searchKeyword
      }

      this.$router.replace({ query: newQuery});
      this.refreshResults()
    },
    toggleCategory: function() {
      this.hideMobileCategory = this.hideMobileCategory ? false : true
    },
  },
  created() {
    if (localStorage.cart) {
      this.cart = localStorage.cart;}

    this.selectedCategoryID = this.$route.query.cid
    this.searchKeyword = this.$route.query.kw

    if(this.$route.query.plan) {
      let plan = parseInt(this.$route.query.plan)

      if (plan != undefined) {
        this.selectedCategoryID = plan;
      }
    }
  },
  computed: {
    showLanding: function() {
      const result = this.enableNewLanding === 'true' && !(this.selectedCategoryID || this.searchKeyword)
      return result
    }
  },
  mounted()  {
    this.refreshResults()
  },
  watch: {
    cart() {
      localStorage.cart = this.cart;
    }
  }
};
</script>
